<template>
  <div>
    <div id="modal-client" class="modal fade" aria-hidden="true" ref="addClient">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">Add new client</h3></div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-3"><label for="oName">Name</label></div>
                    <div class="col-lg-9"><input type="text" name="name" id="oName" ref="oName" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oContact">Contact</label></div>
                    <div class="col-lg-9"><input type="text" name="contact" id="oContact" ref="oContact" placeholder="" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12"><button class="btn btn-primary" @click="addClient">Save</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Clients</h5>
        <div class="ibox-tools">
          <button class="label label-primary pull-right" data-toggle="modal" data-target="#modal-client">New client</button>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Name</th>
            <th>Open orders</th>
            <th>All orders</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="client in clients" v-bind:key="client.id">
            <td><router-link :to="'/client/' + client.id">{{ client.name }}</router-link></td>
            <td>{{ client.orderCount.open }}</td>
            <td>{{ client.orderCount.all }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'List',
  data () {
    return {
      loaded: false,
      clients: []
    }
  },
  mounted () {
    this.loadClients()
  },
  methods: {
    loadClients () {
      axios.get(process.env.API + '/clients').then((response) => {
        this.clients = []
        response.data.data.forEach((client) => {
          this.clients.push(client)
        })
        this.loaded = true
      })
    },
    addClient () {
      axios.post(process.env.API + '/client/', {
        name: this.$refs.oName.value,
        data: {
          contact: this.$refs.oContact.value
        }
      })
        .then(response => {
          this.loadClients()
          $('#modal-client').modal('hide')
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Client/List.vue